/**
 * this mixins get long name and add &shy; - symbols between letters
 * we need it to show hyphens when words break 
 */

export default {
    methods: {
        hyphensWords(text) {
            let wordsArr = text.split(' ')
            wordsArr = wordsArr.map( item => {
                if (item.length < 20) {
                    return item
                }else {
                    const itemArr = item.split('')
                    const newItem = []
                    for(let i = 0; i <= itemArr.length; i++ ) {
                        if(i%3 === 0) {
                            newItem.push('&shy;')
                            newItem.push(...itemArr.slice(i, i + 3))
                        }
                    }
                    return newItem.join('')
                }
            })
            return wordsArr.join(' ')
        }
    }
}